import { all } from 'redux-saga/effects'

import profileSagaWatcher from './profile'
import facilitySagaWatcher from './facility'
import overViewSagaWatcher from './overview'
import devicesSagaWatcher from './devices'
import watchConfirmationSagas from './confirmationModal'
import equipmentSagaWatcher from './equipment'
import alertsSagaWocher from './alerts'
import helpSupportSagaWatcher from './helpSupport'

export function* rootSagas() {
  yield all([
    profileSagaWatcher(),
    facilitySagaWatcher(),
    overViewSagaWatcher(),
    devicesSagaWatcher(),
    watchConfirmationSagas(),
    equipmentSagaWatcher(),
    alertsSagaWocher(),
    helpSupportSagaWatcher(),
  ])
}
